<router-outlet />
<ng-template #loadingTemplate>
  <div class="loading-overlay">
    <div class="spinner-container">
      <mat-spinner [diameter]="50" color="primary" />
    </div>
  </div>
</ng-template>
